import { FC } from 'react';
import { IconType } from 'react-icons';
import ReactIcon from '../ReactIcon';
import { WrapText, WuthoutElementsWrap } from './styles';

type Props = {
    title: string;
    icon: IconType;
};

export const WithoutElementsShop: FC<Props> = ({ title, icon }) => {
    return (
        <WuthoutElementsWrap>
            <ReactIcon Icon={icon} size={'2rem'} />
            <WrapText>
                <span>{title}</span>
                <span>
                    <strong>Mas não desista!</strong> Continue explorando e
                    verifique novamente mais tarde!
                </span>
            </WrapText>
        </WuthoutElementsWrap>
    );
};

export const WithoutElementsShopFirstHeat: FC<Props> = ({ icon }) => {
    return (
        <WuthoutElementsWrap>
            <ReactIcon Icon={icon} size={'2rem'} />
            <WrapText>
                <span>
                    Não há bônus disponíveis para agendamento nesta data.
                </span>
                <span>
                    <strong>Mas não desista!</strong> Verifique se você já agendou um bônus para hoje ou tente outra data.
                </span>
            </WrapText>
        </WuthoutElementsWrap>
    );
};
